import classNames from 'classnames';

import Button from 'components/ui/Button';

import InfoPopover from 'components/ui/InfoPopover/InfoPopover';
import styles from './Badge.module.scss';

export type BadgeColor =
    | 'primary'
    | 'success'
    | 'danger'
    | 'warn'
    | 'successLight'
    | 'info'
    | 'light'
    | 'successOutline';

export interface IBadgeProps {
    content: React.ReactNode;
    color: BadgeColor;
    variant?: 'default' | 'circle';
    className?: string;
    withDeleteIcon?: boolean;
    translateContent?: boolean;
    onClick?: () => void;
    withInfo?: React.ReactNode;
}

/**
 * @depracted use AmnisBadge
 */
const Badge = ({
    content,
    className,
    color,
    variant = 'default',
    withDeleteIcon = false,
    translateContent = true,
    onClick,
    withInfo,
}: IBadgeProps) => {
    return (
        <div className={styles.container}>
            <span
                className={classNames(styles.badge, className, {
                    [styles[color]]: color,
                    [styles.circle]: variant === 'circle',
                })}
                translate={translateContent ? 'yes' : 'no'}
            >
                {content}
                {withDeleteIcon ? (
                    <div className={styles.deleteIcon}>
                        <Button
                            icon="close"
                            variant="text"
                            color="secondary"
                            iconOnly
                            onClick={onClick}
                        />
                    </div>
                ) : null}
            </span>
            {withInfo ? <InfoPopover content={withInfo} /> : null}
        </div>
    );
};

export default Badge;
